<template>
  <div>
    <b-navbar toggleable="md" type="dark" variant="dark" class="nav_bg">

      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

      <b-navbar-brand class="logo" to="home">
        <img style="height: 34px" src="@/assets/img/logo.png">
      </b-navbar-brand>

      <b-collapse is-nav id="nav_collapse">

        <!-- <b-navbar-nav>
          <b-nav-item to="/home">首页</b-nav-item>
          <b-nav-item to="/notify">大象审核</b-nav-item>
          <b-nav-item to="/admin">系统管理</b-nav-item>
        </b-navbar-nav> -->
        <b-navbar-nav>
          <template v-for="manu in leftManu">

            <b-nav-item :exact="true" v-if="manu.needLogin&&manu.children&&manu.role.indexOf(role)!==-1"
                        @mouseover="manu.showSubManu = true;" @mouseout="manu.showSubManu = false">
              {{manu.title}}
              <ul class="sub_manu" v-if="manu.showSubManu">
                <li v-for="subManu in manu.children" v-if="subManu.role.indexOf(role)!==-1">
                  <router-link class="manu_link" :to="subManu.url">{{subManu.title}}</router-link>
                </li>
              </ul>
            </b-nav-item>
            <b-nav-item :exact="true" v-else-if="manu.needLogin&&manu.role.indexOf(role)!==-1" :to="manu.url">
              {{manu.title}}
            </b-nav-item>
            <b-nav-item :exact="true" v-else-if="!manu.needLogin&&manu.children" :to="manu.url"
                        @mouseover="manu.showSubManu = true;" @mouseout="manu.showSubManu = false">
              <li v-for="subManu in manu.children" v-if="subManu.role.indexOf(role)!==-1">
                <router-link class="manu_link" :to="subManu.url">{{subManu.title}}</router-link>
              </li>
            </b-nav-item>
            <b-nav-item :exact="true" v-else-if="!manu.needLogin" :to="manu.url">
              {{manu.title}}
            </b-nav-item>
          </template>
          <b-nav-item :exact="true" to="/about">
            关于
          </b-nav-item>
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <li class="small_nav">
            <span class="username">亲爱的{{ username ? (' [' + username + ']') : '游客' }}, 欢迎您！</span>
          </li>
          <li class="small_nav" v-if="username" @mouseover="userManu.showSubManu = true"
              @mouseout="userManu.showSubManu = false">
            <font-awesome-icon icon="user"/>
            <ul class="sub_manu" v-if="userManu.showSubManu">
              <li v-for="subMenu in userManu.children">
                <router-link class="manu_link" :to="subMenu.url">{{subMenu.title}}</router-link>
              </li>
            </ul>
          </li>
          <li class="small_nav" v-else @click="$router.push({name:'login'})">登录</li>
          <!-- <b-nav-item-dropdown right v-if="username">
            <template slot="button-content" class="username">
              <img style="height: 30px; width: auto;" :src="logoImg">
              <span style="padding-left: 10px;">{{ username }}</span>
            </template>
            <b-dropdown-item to="/config" v-if="role == 'admin'">系统设置</b-dropdown-item>
            <b-dropdown-item @click="logout">退出</b-dropdown-item>
          </b-nav-item-dropdown> -->
          <li class="small_nav" v-if="configManu.role.indexOf(role)!==-1" @mouseover="configManu.showSubManu = true;"
              @mouseout="configManu.showSubManu = false">
            <font-awesome-icon icon="cog"/>
            <ul class="sub_manu" v-if="configManu.showSubManu">
              <li v-for="subMenu in configManu.children" v-if="subMenu.role.indexOf(role)!==-1">
                <router-link class="manu_link" :to="subMenu.url">{{subMenu.title}}</router-link>
              </li>
            </ul>
          </li>

          <!-- <li class="small_nav" v-if="username">
            <font-awesome-icon icon="question-circle" />
          </li> -->
          <li class="small_nav" v-if="username" v-b-tooltip.hover.left title="点击退出登录">
            <font-awesome-icon icon="power-off" class="fa_icon" @click="logout"/>
          </li>
        </b-navbar-nav>

      </b-collapse>
    </b-navbar>
  </div>
</template>
<script>
import { logout } from '@/api/user'
/* eslint-disable */
export default {
  data () {
    return {
      // todo 需要直接用路由定义的
      username: this.$store.getters.username,
      role: this.$store.getters.role,
      logoImg: this.$store.getters.user_logo,
      leftManu: [
        {
          title: '首页',
          url: '/',
          needLogin: false
        },
        {
          title: '图片审核',
          url: '/notify',
          needLogin: true,
          role: ['checker', 'researcher', 'phone_admin', 'system_admin']
        },
        {
          title: '社区故事',
          url: '/story',
          needLogin: false
        }
      ],
      userManu: {
        // title: '系统管理',
        // url: '/system',
        showSubManu: false,
        // role: ['place_admin', 'phone_admin', 'system_admin'],
        children: [
          {
            title: '修改密码',
            url: '/user/changePwd',
            role: ['normal', 'checker', 'researcher', 'phone_admin', 'system_admin']
          },
        ]
      },
      configManu: {
        title: '系统管理',
        url: '/system',
        showSubManu: false,
        role: ['phone_admin', 'system_admin'],
        children: [
          {
            title: '用户管理',
            url: '/system/userManage',
            role: ['system_admin']
          },
          {
            title: '用户片区管理',
            url: '/system/userTownManage',
            role: ['phone_admin', 'system_admin']
          },
          {
            title: '社区故事管理',
            url: '/system/clubStoryManage',
            role: ['phone_admin', 'system_admin']
          },
          {
            title: '相机地点管理',
            url: '/system/cameraManage',
            role: ['phone_admin', 'system_admin']
          },
          {
            title: '首页内容管理',
            url: '/system/homeManage',
            role: ['phone_admin', 'system_admin']
          }
        ]
      }
    }
  },
  components: {},
  mounted() {},
  computed: {
    usernameCpt: function () {
      return this.$store.getters.username
    }
  },
  methods: {
    logout () {
      this.$store.commit('SET_USERNAME', null)
      this.$store.commit('SET_ROLE', null)
      this.$store.commit('SET_USER_LOGO', null)
      logout().then((resp) => {
        // console.log('resp',resp);
      }).catch((error) => {
        // console.log('error',error);
      })
      this.$router.push({ name: 'login' })
      this.$toasted.global.pop_success('退出成功：' + this.username)
    }
  },
  watch: {
    usernameCpt: function (newValue) {
      this.username = newValue
      this.role = this.$store.getters.role
      this.logoImg = this.$store.getters.user_logo
    }
  }

}
</script>
<style lang="scss">
  $color_background: #333E2A; //导航栏背景
  // $color_border: #68B92E; //#edb249; //菜单选中边框颜色
  .logo_title {
    font-size: 30px;
    padding-left: 10px;
    vertical-align: middle;
  }

  #nav_collapse {
    background-color: $color_background;
    z-index: 9;
  }

  .navbar.nav_bg {
    background-color: $color_background !important;
    height: 80px;
    @media screen and(min-width: 825px) {
      padding-left: 40px;
      padding-right: 40px;
    }
    // .navbar-dark .navbar-nav .nav-link:hover,
    // .navbar-dark .navbar-nav .nav-link:focus,
    .logo {
      padding-top: 1px;
      padding-bottom: 1px;
      @media screen and(min-width: 1090px) {
        margin-right: 110px;
      }
      @media screen and(max-width: 567px) {
        img {
          height: 30px;
        }
      }
      @media screen and(max-width: 320px) {
        img {
          height: 20px;
        }
      }
    }
    .nav-link.router-link-exact-active {
      background: #101505;
      color: #fff !important;
    }
    .nav-link {
      height: 80px;
      line-height: 80px;
      padding: 0;
      color: #f1f1f1 !important;
      @media screen and(min-width: 946px) {
        font-size: 18px;
        padding-left: 30px !important;
        padding-right: 30px !important;
      }
      @media screen and(max-width: 946px) {
        font-size: 14px;
      }
    }
    // .username{
    //   color: $font_color_blue;
    // }
    .sub_manu {
      position: absolute;
      min-width: 130px;
      margin-left: -15px;
      list-style: none;
      padding: 15px 0;
      line-height: 1rem;
      background: $color_background;
      border-radius: 3px;
      z-index: 9999;
    }
    //.sub_manu li:not(:last-child){
    //  padding: 0px 0px 15px 0px;
    //}
    .manu_link {
      line-height: 1;
      color: #fff;
    }
    .manu_link:hover {
      color: $color_yellow_light;
      text-decoration: none;
    }
    .sub_manu li {
      padding: 10px 20px;
    }
    .sub_manu li:hover {
      background: #6c9479; //#5786ca;

    }
    .small_nav {
      color: $font_color_second;
      line-height: 80px;
      cursor: pointer;
      padding-right: 15px;
    }
    .small_nav:hover {
      color: $color_yellow_light;
    }
  }

  .username {
    font-size: 14px;
    padding-right: 15px;
  }

</style>
